export default "__VITE_ASSET__oMu5Bq63__"